<h1> <mat-icon class="mat-icon-rtl-mirror">
    collections
</mat-icon>
Добавление модулей
</h1>
<mat-toolbar>

  <span>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon" (click)="refresh()" matTooltip="Обновить содержимое страницы">
      <mat-icon>refresh</mat-icon>
    </button>
  </span>

  <span>
    <td mat-cell *matCellDef="let element"></td>
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
      (click)="openAddModuleDialog()" matTooltip="Добавить содержимое страницы">
      <mat-icon>add</mat-icon>
    </button>
  </span>


  <span class="flexExpand"></span>

  <span>
    <mat-slide-toggle class="example-margin" [(ngModel)]="show_archieved" (change)="refresh()">Показать архивные
    </mat-slide-toggle>
  </span>

</mat-toolbar>
<div class="mat-elevation-z8">

    <mat-form-field>
        <mat-label>Поиск</mat-label>
        <input matInput placeholder="Введите слово для поиска" (keyup)="Filterchange($event)">
    </mat-form-field>

    <table mat-table matSort [dataSource]="dataSourceModules" class="mat-elevation-z8">

        <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

        <!-- ID Column -->
        <ng-container matColumnDef="ID">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let element"> {{element.ID}} </td>
        </ng-container>

        <!-- ShortTitle Column -->
        <ng-container matColumnDef="ShortTitle">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Название</th>
            <td mat-cell *matCellDef="let element"> {{element.ShortTitle}} </td>
        </ng-container>


        <!-- Description Column -->
        <ng-container matColumnDef="Description">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Описание</th>
            <td mat-cell *matCellDef="let element"> {{element.Description}} </td>
        </ng-container>
        <!-- CommandLine Column -->
        <ng-container matColumnDef="CommandLine">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Командная строка</th>
            <td mat-cell *matCellDef="let element"> {{element.CommandLine}} </td>
        </ng-container>
        <!-- InputParametrs Column -->
        <ng-container matColumnDef="InputParametrs">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>Параметры</th>
            <td mat-cell *matCellDef="let element"> {{element.InputParametrs}} </td>
        </ng-container>
        <!-- Security Level -->
        <ng-container matColumnDef="SecurityLevel">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faShieldHalved"></fa-icon>
            </th>
            <td mat-cell *matCellDef="let element"> {{element.SecurityLevel}} </td>
        </ng-container>

        <ng-container matColumnDef="ArchiveSign">
            <th mat-header-cell mat-sort-header *matHeaderCellDef>
                <fa-icon [icon]="faBoxArchive"></fa-icon>
            </th>
            <td mat-cell *matCellDef="let element">
                <mat-checkbox class="example-margin" [(ngModel)]="element.ArchiveSign" (change)="ChangeArchivated(element)"></mat-checkbox>
                
                            
                       
            </td>
        </ng-container>
        <ng-container matColumnDef="Edit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Редактирование</th>
            <td mat-cell *matCellDef="let element">
                <mat-icon class="custom-edit-icon" (click)="openEditModuleDialog(element)" matTooltip="Редактировать элемент">edit</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr (click)="getrow(row)" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,25,25,25,25,100]" showFirstLastButtons>

    </mat-paginator>

</div>
